export interface TaskSwimLaneTypeData {
  title: string;
  style: TaskSwimLaneType;
}

export enum TaskSwimLaneType {
  OVERDUE = 'overdue',
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  NEXT_7_DAYS = 'next-7-Days',
  UPCOMING = 'upcoming',
}
